var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealthOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 7.5C15.9971 7.5 16.4 7.90294 16.4 8.4V9.1H17.1C17.5971 9.1 18 9.50294 18 10C18 10.4971 17.5971 10.9 17.1 10.9H16.4V11.6C16.4 12.0971 15.9971 12.5 15.5 12.5C15.0029 12.5 14.6 12.0971 14.6 11.6V10.9H13.9C13.4029 10.9 13 10.4971 13 10C13 9.50294 13.4029 9.1 13.9 9.1H14.6V8.4C14.6 7.90294 15.0029 7.5 15.5 7.5Z",
    fill: "#023F80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.111 5.69952C13.2389 4.64334 14.5405 4.06981 15.9918 4.00599L16.2656 4C19.4228 4 22 6.56027 22 9.71723C22 12.676 20.9647 14.144 16.4269 17.7784L15.4937 18.5182L13.1296 20.3607C12.4655 20.8783 11.5345 20.8783 10.8704 20.3607L8.18242 18.263C3.12733 14.2688 2 12.8046 2 9.71723C2 6.56027 4.57716 4 7.73438 4C9.2746 4 10.6626 4.57606 11.8723 5.69501L11.994 5.813L12.111 5.69952ZM20.2 9.71723C20.2 7.55704 18.4314 5.8 16.2656 5.8C14.9087 5.8 13.7389 6.41565 12.702 7.70812C12.3441 8.15426 11.6662 8.15771 11.3038 7.71525C10.2408 6.41758 9.06729 5.8 7.73438 5.8C5.56863 5.8 3.8 7.55704 3.8 9.71723C3.8 11.9668 4.59678 13.0977 8.73899 16.4066L9.6128 17.0984L11.9769 18.941C11.9905 18.9515 12.0095 18.9515 12.0231 18.941L14.686 16.8631C19.1332 13.352 20.1192 12.1674 20.1951 10.0108L20.2 9.71723Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthOutline);
export default __webpack_public_path__ + "static/media/health_outline.aa6b237110d7930a8c6dc0e632fa63bc.svg";
export { ForwardRef as ReactComponent };